var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
function setElement(type, element) {
    // default to using element prop if provided
    if (element)
        return element;
    // fall back to type (which defaults to standard)
    switch (type) {
        case 'heading-1':
            return 'h1';
        case 'heading-2':
            return 'h2';
        case 'heading-3':
            return 'h3';
        case 'heading-4':
            return 'h4';
        case 'paragraph':
            return 'p';
        case 'small':
            return 'small';
        case 'standard':
        default:
            return 'span';
    }
}
function setFontSize(theme, type, size) {
    if (size)
        return theme.font.sizes[size];
    switch (type) {
        case 'heading-1':
            return theme.font.primary.size.xxl;
        case 'heading-2':
            return theme.font.primary.size.xl;
        case 'heading-3':
            return theme.font.primary.size.large;
        case 'heading-4':
            return theme.font.primary.size.medium;
        case 'paragraph':
            return theme.font.primary.size.medium;
        case 'small':
            return theme.font.primary.size.small;
        case 'standard':
            return theme.font.primary.size.medium;
        default:
            return '120px';
    }
}
function setFontWeight(theme, type, weight) {
    if (weight)
        return weight;
    switch (type) {
        case 'heading-1':
        case 'heading-2':
        case 'heading-3':
        case 'heading-4':
            return theme.font.primary.weight.bold;
        default:
            return theme.font.primary.weight.normal;
    }
}
function setColor(theme, colorVariant) {
    var themeColorPair = theme.color;
    switch (colorVariant) {
        case 'active':
            return themeColorPair.active.background;
        case 'active-background':
            return themeColorPair.active.background;
        case 'active-foreground':
            return themeColorPair.active.foreground;
        case 'alert':
            return themeColorPair.alert.background;
        case 'alert-background':
            return themeColorPair.alert.background;
        case 'alert-foreground':
            return themeColorPair.alert.foreground;
        case 'background':
            return themeColorPair.background.foreground;
        case 'background-background':
            return themeColorPair.background.background;
        case 'background-foreground':
            return themeColorPair.background.foreground;
        case 'container':
            return themeColorPair.container.foreground;
        case 'container-background':
            return themeColorPair.container.background;
        case 'container-foreground':
            return themeColorPair.container.foreground;
        case 'default':
            return themeColorPair.container.foreground;
        case 'highlight':
            return themeColorPair.highlight.background;
        case 'highlight-background':
            return themeColorPair.highlight.background;
        case 'highlight-foreground':
            return themeColorPair.highlight.foreground;
        case 'info':
            return themeColorPair.info.background;
        case 'info-background':
            return themeColorPair.info.background;
        case 'info-foreground':
            return themeColorPair.info.foreground;
        case 'link':
            return themeColorPair.link.foreground;
        case 'link-background':
            return themeColorPair.link.background;
        case 'link-foreground':
            return themeColorPair.link.foreground;
        case 'outline':
            return themeColorPair.outline.background;
        case 'outline-background':
            return themeColorPair.outline.background;
        case 'outline-foreground':
            return themeColorPair.outline.foreground;
        case 'primary':
            return themeColorPair.primary.background;
        case 'primary-background':
            return themeColorPair.primary.background;
        case 'primary-foreground':
            return themeColorPair.primary.foreground;
        case 'secondary':
            return themeColorPair.secondary.background;
        case 'secondary-background':
            return themeColorPair.secondary.background;
        case 'secondary-foreground':
            return themeColorPair.secondary.foreground;
        case 'section':
            return themeColorPair.section.foreground;
        case 'section-background':
            return themeColorPair.section.background;
        case 'section-foreground':
            return themeColorPair.section.foreground;
        case 'tertiary':
            return themeColorPair.tertiary.background;
        case 'tertiary-background':
            return themeColorPair.tertiary.background;
        case 'tertiary-foreground':
            return themeColorPair.tertiary.foreground;
        case 'warning':
            return themeColorPair.warning.background;
        case 'warning-background':
            return themeColorPair.warning.background;
        case 'warning-foreground':
            return themeColorPair.warning.foreground;
        default:
            return themeColorPair.container.foreground;
    }
}
var StyledText = styled.span.attrs(function (_a) {
    var alignment = _a.alignment, casing = _a.casing, colorVariant = _a.colorVariant, type = _a.type, weight = _a.weight, size = _a.size;
    return ({
        alignment: alignment,
        casing: casing,
        colorVariant: colorVariant,
        type: type,
        weight: weight,
        size: size,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var alignment = props.alignment, casing = props.casing, colorVariant = props.colorVariant, theme = props.theme, type = props.type, weight = props.weight, size = props.size;
    var hoverCursor = (colorVariant === null || colorVariant === void 0 ? void 0 : colorVariant.includes('link')) ? 'pointer' : 'auto';
    var hoverDecoration = (colorVariant === null || colorVariant === void 0 ? void 0 : colorVariant.includes('link')) ? 'underline' : 'none';
    // TODO: Update font weight override routine to use theme values instead of "bold" or "normal".
    // TODO: Figure out a better way to do this check... needed for code coverage.
    if (theme && JSON.stringify(theme) !== '{}') {
        return "\n        color: " + setColor(theme, colorVariant) + ";\n        font-family: " + theme.font.primary.family + ";\n        font-size: " + setFontSize(theme, type, size) + ";\n        font-weight: " + setFontWeight(theme, type, weight) + ";\n        line-height: " + (type === 'paragraph' ? '24px' : setFontSize(theme, type, size)) + ";\n        margin: 0;\n        margin-bottom: " + (type === 'paragraph' ? theme.size.spacer.medium : '0') + ";\n        padding: 0;\n        text-align: " + alignment + ";\n        text-transform: " + (!casing ? 'none' : casing) + ";\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        &:hover {\n          cursor: " + hoverCursor + ";\n          text-decoration: " + hoverDecoration + ";\n        }\n      ";
    }
    return "\n      color: Hotpink;\n      font-size: 120px;\n    ";
});
export function SAText(_a) {
    var alignment = _a.alignment, casing = _a.casing, colorVariant = _a.colorVariant, onClick = _a.onClick, text = _a.text, type = _a.type, weight = _a.weight, size = _a.size, children = _a.children, as = _a.as, rest = __rest(_a, ["alignment", "casing", "colorVariant", "onClick", "text", "type", "weight", "size", "children", "as"]);
    var RenderComponent = onClick ? (React.createElement(StyledText, __assign({ as: setElement(type, as), alignment: alignment, casing: casing, colorVariant: colorVariant, onClick: onClick, type: type, weight: weight, size: size }, rest), children || text)) : (React.createElement(StyledText, __assign({ as: setElement(type, as), alignment: alignment, casing: casing, colorVariant: colorVariant, type: type, weight: weight, size: size }, rest), children || text));
    return RenderComponent;
}
SAText.defaultProps = {
    alignment: 'left',
    casing: undefined,
    text: 'Lorem Ipsum',
    type: 'standard',
    weight: undefined,
};
var templateObject_1;
//# sourceMappingURL=text.component.js.map